import React from 'react';
import styled from 'styled-components';

import { DEFAULT_PORTAL_DISABLED_MESSAGE } from '@rebound/shared-models/retailer/retailer.model';

type PortalDisabledViewProps = {
  message?: string | null;
  children?: React.ReactNode;
};

export const PortalDisabledView = ({
  message,
  children,
}: PortalDisabledViewProps) => (
  <>
    <BlurredContent aria-hidden="true" inert>
      {children}
    </BlurredContent>
    <Overlay
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="portal-disabled-title"
      data-testid="portal-disabled-view"
    >
      <Card>
        <Title id="portal-disabled-title">Returns portal unavailable</Title>
        <Message>{message?.trim() || DEFAULT_PORTAL_DISABLED_MESSAGE}</Message>
      </Card>
    </Overlay>
  </>
);

const BlurredContent = styled.div`
  filter: blur(6px);
  pointer-events: none;
  user-select: none;
  max-height: 100vh;
  overflow: hidden;
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.35);
`;
const Card = styled.div`
  max-width: 560px;
  width: 100%;
  padding: 32px;
  background: #fff;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 16px;
`;

const Message = styled.p`
  font-size: 16px;
  margin: 0;
  white-space: pre-line;
  word-break: break-word;
`;
